import {
  GET_SAME_WASTE_STREAM_ELIGIBILITY_PENDING,
  GET_SAME_WASTE_STREAM_ELIGIBILITY_FULFILLED,
  GET_SAME_WASTE_STREAM_ELIGIBILITY_FAILED,
  GET_NEW_WASTE_STREAM_ELIGIBILITY_FAILED,
  GET_NEW_WASTE_STREAM_ELIGIBILITY_FULFILLED,
  GET_NEW_WASTE_STREAM_ELIGIBILITY_PENDING,
  GET_SERVICE_CHANGE_CRITERIA_FULFILLED,
  GET_SERVICE_CHANGE_CRITERIA_PENDING,
  GET_SERVICE_CHANGE_CRITERIA_FAILED,
  SET_SC_SELECTED_SERVICE,
  SET_SC_SELECTED_WASTE_STREAM,
  GET_SERVICE_CHANGE_DATES_INFO_PENDING,
  GET_SERVICE_CHANGE_DATES_INFO_FAILED,
  GET_SERVICE_CHANGE_DATES_INFO_FULFILLED,
  RESET_SERVICE_CHANGE,
  GET_SERVICE_CHANGE_PRICE_INFO_FAILED,
  GET_SERVICE_CHANGE_PRICE_INFO_FULFILLED,
  GET_SERVICE_CHANGE_PRICE_INFO_PENDING,
  SUBMIT_SERVICE_CHANGE_DETAILS_FAILED,
  SUBMIT_SERVICE_CHANGE_DETAILS_FULFILLED,
  SUBMIT_SERVICE_CHANGE_DETAILS_PENDING,
  SET_SC_SELECTED_CUSTOMER_ID,
  CLEAR_SC_SUBMIT_DETAILS,
  CLEAR_SC_ON_SERVICE_CHANGE_TYPE,
  SET_SUBMIT_ADD_FLOW_ANALYTICS,
  SET_SUBMIT_EDIT_FLOW_ANALYTICS,
  RESET_USER_ACCOUNT,
  SET_SHOW_ALL_SERVICE_OPTIONS,
  SET_REQUEST_BUTTON_CLICKED,
} from "constants-lib/actionTypes"
import { API_STATUSES } from "constants-lib/common"

const initialState = {
  selectedCustomerId: "",
  addSameWasteStreamEligibility: {},
  getSameWasteStreamEligibilityStatus: ``,
  addNewWasteStreamEligibility: {},
  getNewWasteStreamEligibilityStatus: ``,
  serviceChangeCriteria: {},
  getServiceCriteriaStatus: ``,
  selectedWasteStream: {},
  selectedService: {},
  serviceChangeDatesInfo: {},
  getServiceChangeDatesInfoStatus: ``,
  getServiceChangePriceInfoStatus: ``,
  serviceChangePriceInfo: {},
  serviceChangeSubmitDetails: {},
  serviceChangeSubmitDetailsStatus: ``,
  editFlowConfirmAnalyticsData: {},
  addFlowConfirmAnalyticsData: {},
  submitFor: "edit",
  isSeeAllOptionsClicked: false,
  isRequestButtonClicked: false,
}

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case GET_SAME_WASTE_STREAM_ELIGIBILITY_PENDING:
      return {
        ...state,
        getSameWasteStreamEligibilityStatus: API_STATUSES.PENDING,
      }
    case GET_SAME_WASTE_STREAM_ELIGIBILITY_FULFILLED:
      return {
        ...state,
        getSameWasteStreamEligibilityStatus: API_STATUSES.FULFILLED,
        addSameWasteStreamEligibility: action.payload,
      }
    case GET_SAME_WASTE_STREAM_ELIGIBILITY_FAILED:
      return {
        ...state,
        getSameWasteStreamEligibilityStatus: API_STATUSES.FAILED,
      }
    case GET_NEW_WASTE_STREAM_ELIGIBILITY_PENDING:
      return {
        ...state,
        getNewWasteStreamEligibilityStatus: API_STATUSES.PENDING,
      }
    case GET_NEW_WASTE_STREAM_ELIGIBILITY_FULFILLED:
      return {
        ...state,
        getNewWasteStreamEligibilityStatus: API_STATUSES.FULFILLED,
        addNewWasteStreamEligibility: action.payload,
      }
    case GET_NEW_WASTE_STREAM_ELIGIBILITY_FAILED:
      return {
        ...state,
        getNewWasteStreamEligibilityStatus: API_STATUSES.FAILED,
      }
    case GET_SERVICE_CHANGE_CRITERIA_FULFILLED:
      return {
        ...state,
        getServiceCriteriaStatus: API_STATUSES.FULFILLED,
        serviceChangeCriteria: action.payload,
      }
    case GET_SERVICE_CHANGE_CRITERIA_PENDING:
      return {
        ...state,
        getServiceCriteriaStatus: API_STATUSES.PENDING,
      }
    case GET_SERVICE_CHANGE_CRITERIA_FAILED:
      return {
        ...state,
        getServiceCriteriaStatus: API_STATUSES.FAILED,
      }
    case GET_SERVICE_CHANGE_DATES_INFO_PENDING:
      return {
        ...state,
        getServiceChangeDatesInfoStatus: API_STATUSES.PENDING,
      }
    case GET_SERVICE_CHANGE_DATES_INFO_FULFILLED:
      return {
        ...state,
        getServiceChangeDatesInfoStatus: API_STATUSES.FULFILLED,
        serviceChangeDatesInfo: action.payload,
      }
    case GET_SERVICE_CHANGE_DATES_INFO_FAILED:
      return {
        ...state,
        getServiceChangeDatesInfoStatus: API_STATUSES.FAILED,
      }
    case SET_SC_SELECTED_SERVICE:
      return {
        ...state,
        selectedService: action.payload,
      }
    case SET_SC_SELECTED_WASTE_STREAM:
      return {
        ...state,
        selectedWasteStream: action.payload,
      }
    case SET_SC_SELECTED_CUSTOMER_ID:
      return {
        ...state,
        selectedCustomerId: action.payload,
      }

    case GET_SERVICE_CHANGE_PRICE_INFO_PENDING:
      return {
        ...state,
        getServiceChangePriceInfo: {},
        getServiceChangePriceInfoStatus: API_STATUSES.PENDING,
      }
    case GET_SERVICE_CHANGE_PRICE_INFO_FULFILLED:
      return {
        ...state,
        getServiceChangePriceInfoStatus: API_STATUSES.FULFILLED,
        serviceChangePriceInfo: action.payload,
      }
    case GET_SERVICE_CHANGE_PRICE_INFO_FAILED:
      return {
        ...state,
        getServiceChangePriceInfoStatus: API_STATUSES.FAILED,
      }
    case SET_SUBMIT_ADD_FLOW_ANALYTICS:
      return {
        ...state,
        submitFor: "add",
        addFlowConfirmAnalyticsData: action.payload,
      }
    case SET_SUBMIT_EDIT_FLOW_ANALYTICS:
      return {
        ...state,
        submitFor: "edit",
        editFlowConfirmAnalyticsData: action.payload,
      }
    case SUBMIT_SERVICE_CHANGE_DETAILS_PENDING:
      return {
        ...state,
        serviceChangeSubmitDetailsStatus: API_STATUSES.PENDING,
        serviceChangeSubmitDetails: {},
      }
    case SUBMIT_SERVICE_CHANGE_DETAILS_FULFILLED:
      return {
        ...state,
        addSameWasteStreamEligibility: {},
        getSameWasteStreamEligibilityStatus: ``,
        addNewWasteStreamEligibility: {},
        getNewWasteStreamEligibilityStatus: ``,
        serviceChangeSubmitDetailsStatus: API_STATUSES.FULFILLED,
        serviceChangeSubmitDetails: action.payload,
      }
    case SUBMIT_SERVICE_CHANGE_DETAILS_FAILED:
      return {
        ...state,
        serviceChangeSubmitDetailsStatus: API_STATUSES.FAILED,
        serviceChangeSubmitDetails: {},
      }

    case CLEAR_SC_SUBMIT_DETAILS:
      return {
        ...state,
        serviceChangeSubmitDetails: {},
        serviceChangeSubmitDetailsStatus: ``,
        editFlowConfirmAnalyticsData: {},
        addFlowConfirmAnalyticsData: {},
        submitFor: "edit",
      }

    case RESET_SERVICE_CHANGE:
      return {
        ...state,
        addSameWasteStreamEligibility: {},
        getSameWasteStreamEligibilityStatus: ``,
        addNewWasteStreamEligibility: {},
        getNewWasteStreamEligibilityStatus: ``,
        serviceChangeCriteria: {},
        getServiceCriteriaStatus: ``,
        selectedWasteStream: {},
        selectedService: {},
        serviceChangeDatesInfo: {},
        getServiceChangeDatesInfoStatus: ``,
        getServiceChangePriceInfoStatus: ``,
        serviceChangePriceInfo: {},
        serviceChangeSubmitDetailsStatus: ``,
      }

    case CLEAR_SC_ON_SERVICE_CHANGE_TYPE:
      return {
        ...state,
        serviceChangeCriteria: {},
        getServiceCriteriaStatus: ``,
        serviceChangeDatesInfo: {},
        getServiceChangeDatesInfoStatus: ``,
        getServiceChangePriceInfoStatus: ``,
        serviceChangePriceInfo: {},
        serviceChangeSubmitDetails: {},
        serviceChangeSubmitDetailsStatus: ``,
        editFlowConfirmAnalyticsData: {},
        addFlowConfirmAnalyticsData: {},
        submitFor: "edit",
      }

    case RESET_USER_ACCOUNT:
      return {
        ...initialState,
      }

    case SET_SHOW_ALL_SERVICE_OPTIONS:
      return {
        ...state,
        isSeeAllOptionsClicked: action.payload,
      }

    case SET_REQUEST_BUTTON_CLICKED:
      return {
        ...state,
        isRequestButtonClicked: action.payload,
      }

    default:
      return state
  }
}
